import dayjs from 'dayjs';
import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes, exhibitionTypes } from '@/types';
import { SEARCH_SCOPES } from '@/tools/consts';
import { generateUUID } from '@/tools/helpers';
/**
 * This action open the ui--search with scope Events,
 * it shows all Events chronological. Passed Events are not shown.
 * Events sperated by monthly seperators
 *
 * @param {*} store
 */
export default function({ rootState, commit, dispatch }, { options = {} }) {
	const data = rootState.calendarEvents.map(event => {
		// transform to list component compatible form
		return Object.assign({}, event, {
			id: event.id,
			key: generateUUID(),
			class: 'data--' + event.id,
			active: false,
			tag: dayjs(event.date).format('D.M dddd MMMM'),
			// tag: `${event.date.getDate()}.${event.date.getMonth()} ${getWeekDayName(event.date.getDay() )} ${getMonthName(event.date.getMonth())}` // FIXME is this equvalent with moment?
			url: '',
			role: 'link',
			click: () => {
				commit(mutationTypes.viewStateSetUiState, {
					id: uiComponents.uiSearchCalendar,
					uiState: uiStates.hidden,
				});
				dispatch(actionTypes.pushUrl, {
					url: `/${exhibitionTypes.calendar}/${event.id}`,
					replace: false,
				});
			},
		});
	});
	const alterationFunctions = [
		/* eslint-disable no-nested-ternary */
		array => array.sort((a, b) => (a.date > b.date ? 1 : a.date < b.date ? -1 : 0)), // order chronological,
		function(array) {
			return array.reduce(
				// Add Monthly Separators
				(acc, entry) => {
					const momentDate = dayjs(entry.date);
					const dateString = momentDate.format('MMMM YYYY');
					if (dateString !== acc.seperator) {
						// add new alpabetic Seperator
						acc.seperator = dateString;
						acc.result.push({
							isSeperator: true,
							name: `${dateString}`,
							class: `separator--${dateString}`,
							iconName: 'separator',
							title: momentDate.format('MMMM'),
							description: momentDate.format('YYYY'),
						});
					}
					acc.result.push(entry);
					return acc;
				},
				{ seperator: null, result: [] }
			).result;
		},
	];

	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.calendar,
		data,
		searchOptions: {
			keys: ['tag', 'title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		alterationFunctions,
		options,
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchCalendar,
		uiState: uiStates.maximised,
	});
}
